module.exports = __webpack_public_path__ + "img/screen.add6c2e8.png";